import MaterialStock from "./MaterialStock";

export default function PurchaseInvoices() {
  return <MaterialStock forcedEntryType="purchase" />;
}
